export const DATA_STORE_MAIN = 'DATA_STORE_MAIN';
export const DATA_STORE_JOB = 'DATA_STORE_JOB';
export const FILTER_STORE = 'FILTER_STORE';
export const SET_RESULT_COUNT = 'SET_RESULT_COUNT';

export const GIO_EVENT_KEYS = {
  CAREER_POSITION_CLICKS: 'career_position_clicks',
};

export const GIO_ATTRIBUTE_KEYS = {
  CAREER_PAGE_SOURCE: 'career_page_source',
  CAREER_POSITION_CATEGORY: 'career_position_category',
  CAREER_POSITION_ID: 'career_position_id',
  CAREER_POSITION_NAME: 'career_position_name',
};
